import { supabase } from "~/integrations/supabase/client";
import type { Database } from "~/types/supabase";

/** One unified stock-adjustment row (products + ingredients), from the RPC. */
export type UnifiedAdjustment =
  Database["public"]["Functions"]["get_stock_adjustments_unified"]["Returns"][number];

export const inventoryAdjustmentsService = {
  async getAll(filters?: {
    from?: string;
    to?: string;
    itemType?: string;
    search?: string;
  }): Promise<UnifiedAdjustment[]> {
    const { data, error } = await supabase.rpc("get_stock_adjustments_unified", {
      p_from: filters?.from || null,
      p_to: filters?.to || null,
      p_item_type:
        filters?.itemType && filters.itemType !== "all" ? filters.itemType : null,
      p_search: filters?.search?.trim() || null,
    });
    if (error) throw error;
    return (data ?? []) as UnifiedAdjustment[];
  },
};
